const buildSbmParams = (combinedDay, dayOrDate, operationType, SBMId) => {
    let startTime = combinedDay[0][0];
    let endTime = combinedDay[combinedDay.length - 1][1];
    let breakList = [];
    for (let i = 0; i <= combinedDay.length - 2; i ++) {
        breakList.push({"start_time":combinedDay[i][1], "end_time":combinedDay[i + 1][0]});
    };
    let sbmParamsObject = {};
    if (operationType === "recurring") {
        sbmParamsObject = {
                    "start_time": startTime,
                    "end_time": endTime,
                    "is_day_off": 0,
                    "breaktime": breakList,
                    "index": dayOrDate.toString(),
                    "name": "",
                    "date": "",
                    "unit_group_id": SBMId.toString(),
                    "event_id": "",
        };
    };
    if (operationType === "exception") {
        sbmParamsObject = {
            "start_time": startTime,
            "end_time": endTime,
            "is_day_off": 0,
            "breaktime": breakList,
            "index": "",
            "name": "",
            "date": dayOrDate,
            "unit_group_id": SBMId.toString(),
            "event_id": "",
        };
    };
    return sbmParamsObject;
};

export default buildSbmParams;


// WEBPACK FOOTER //
// ./src/js/containers/ProviderContainer/utils/buildSbmParams.js